module.exports = __webpack_public_path__ + "img/sap.77f4537d.svg";